import { Link } from "react-router-dom";
import SEO from "../components/SEO";

export default function NotFound() {
  return (
    <>
      <SEO title="Not Found — NEXIRT" description="This page isn't where you left it." path="/404" />
      <section className="nx-container py-32 text-center">
        <div className="font-mono text-xs tracking-[0.18em] text-nx-accent">404</div>
        <h1 className="mt-4 font-display text-4xl font-semibold md:text-6xl">
          This page isn't where you left it.
        </h1>
        <p className="mt-5 text-nx-text-dim">Neither is the rest of the internet — but we can help with that.</p>
        <Link to="/" className="nx-btn-primary mt-8 inline-flex">Back to home</Link>
      </section>
    </>
  );
}
